import { SettingsList } from '../../ui/ProfilesList/ProfilesList'

export const SettingsMenuPage = () => {
  return <SettingsList isOpen />
}
